export const supplier_model = {
  Codigo: null,
  Descripcion: '',
  CodigoSecundario: '',
  Activo: true,
};

export const supplier_filters = {
  Descripcion: '',
  CodigoSecundario: '',
  Activo: true,
};
